import {
    ADD_PHRASES_START_INPUT_ITEMS,
    CLOSE_PHRASES_SELECTOR_WIZARD,
    FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD,
    OPEN_PHRASES_SELECTOR_WIZARD,
    PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST,
    PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST,
    PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY,
    PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT,
    PHRASES_SELECTOR_DELETE_START_PHRASES,
    PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST,
    PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST,
    PHRASES_SELECTOR_SELECTION_CHANGE,
    PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD,
    PhrasesSelectorWizardAction,
    SelectionWizardListName,
    SHOW_PHRASES_SELECTOR_WIZARD,
    UPDATE_PHRASES_SELECTOR_WIZARD_STATE
} from '../actions/phrasesSelectorWizard';
import {
    getNewChosenWordsList,
    getNewMinusWordsList
} from '../service/PhrasesSelectorWizard/PhrasesSelectorWizard';
import {
    PhrasesSelectorListItem,
    PhrasesSelectorWizardState
} from '../typings/phrases';
import { PhrasesSelectorWizardsState, State } from '../typings/state';

const phrasesSelectorWizardInitialState = {
    groupInfo: {
        id: '',
        minusKeywords: [],
        regionIds: [],
        name: '',
        campaign: {
            name: '',
            id: '',
            strategy: {
                isAutoBudget: false
            }
        }
    },
    isVisible: false,
    isInProgress: false,
    startPhrases: [],
    chosenPhrases: [],
    minusWordsList: [],
    keywordsStat: {},
    phrasesSelection: {},
    columnsVisibility: {
        [SelectionWizardListName.similarPhrases]: true,
        [SelectionWizardListName.chosenPhrases]: true
    },
    priceContext: undefined
};

export const getPhrasesSelectorWizardInitialState = (): PhrasesSelectorWizardState =>
    phrasesSelectorWizardInitialState;

export function phrasesSelectorWizard(
    state: PhrasesSelectorWizardsState = {},
    action: PhrasesSelectorWizardAction,
    fullState: State
): PhrasesSelectorWizardsState {
    const wizardId = action.wizardId;
    const wizardState =
        state[wizardId] || getPhrasesSelectorWizardInitialState();

    switch (action.type) {
        case UPDATE_PHRASES_SELECTOR_WIZARD_STATE: {
            const keywordsStat = {
                ...wizardState.keywordsStat,
                ...(action.state.keywordsStat || {})
            };

            const startPhrases =
                action.state.startPhrases || wizardState.startPhrases;

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    keywordsStat,
                    startPhrases,
                    isInProgress: action.state.isInProgress
                }
            };
        }
        case PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST: {
            const chosenPhrases = getNewChosenWordsList(
                wizardState.chosenPhrases,
                action.items
            );

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    chosenPhrases
                }
            };
        }
        case PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST: {
            const chosenPhrases = wizardState.chosenPhrases.filter(
                phrase =>
                    !action.items.some(
                        (el: PhrasesSelectorListItem) => el.text === phrase.text
                    )
            );

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    chosenPhrases
                }
            };
        }

        case PHRASES_SELECTOR_DELETE_START_PHRASES: {
            const startPhrases = wizardState.startPhrases.filter(
                phrase =>
                    !action.items.some(
                        (el: PhrasesSelectorListItem) => el.text === phrase.text
                    )
            );

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    startPhrases
                }
            };
        }

        case PHRASES_SELECTOR_SELECTION_CHANGE: {
            const list = wizardState[
                action.listName
            ] as PhrasesSelectorListItem[];

            const phrasesSelection = {
                ...wizardState.phrasesSelection
            };

            list.forEach(({ text }: PhrasesSelectorListItem, index) => {
                phrasesSelection[text] = action.selection[index];
            });

            const newList = list.map((el: PhrasesSelectorListItem) => ({
                ...el,
                selected: phrasesSelection[el.text]
            }));

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    phrasesSelection,
                    [action.listName]: newList
                }
            };
        }

        case PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST: {
            const minusWordsList = wizardState.minusWordsList.filter(
                phrase => !action.items.some(el => el.text === phrase.text)
            );

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isInProgress: true,
                    minusWordsList
                }
            };
        }

        case PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST: {
            const minusWordsList = getNewMinusWordsList(
                wizardState.startPhrases,
                wizardState.minusWordsList,
                action.items
            );

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isInProgress: true,
                    minusWordsList
                }
            };
        }

        case OPEN_PHRASES_SELECTOR_WIZARD: {
            const { startPhrases } = action.groupInfo;

            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    groupInfo: action.groupInfo,
                    startPhrases: startPhrases ? startPhrases : [],
                    chosenPhrases: [],
                    minusWordsList: [],
                    priceContext: phrasesSelectorWizardInitialState.priceContext
                }
            };
        }

        case SHOW_PHRASES_SELECTOR_WIZARD: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isVisible: true
                }
            };
        }

        case CLOSE_PHRASES_SELECTOR_WIZARD: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isVisible: false,
                    isInProgress: false
                }
            };
        }

        case ADD_PHRASES_START_INPUT_ITEMS: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isInProgress: true
                }
            };
        }

        case FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isInProgress: true
                }
            };
        }

        case PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    columnsVisibility: {
                        ...wizardState.columnsVisibility,
                        ...action.value
                    }
                }
            };
        }

        case PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    priceContext: action.value
                }
            };
        }

        case PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD: {
            return {
                ...state,
                [wizardId]: {
                    ...wizardState,
                    isInProgress: true
                }
            };
        }

        default:
            return state;
    }
}
